import styled, { css } from 'styled-components';
import Heart from 'core/icons/Heart';
import { getColor, StyleVars, heartPoof, typeScale } from 'core/utils';
import { size } from 'styled-manila';

export const FavHeart = styled(Heart)`
	${size(typeScale(2.5))}
	transform-origin: center center;
	transition: all 0.3s ease-out;
`;

export const StableHeart = styled(FavHeart)`
	position: relative;
`;

export const FloatHeart = styled(FavHeart)`
	position: absolute;
	left: 10px;
	top: 10px;
	opacity: 0;
	fill: ${getColor("salmon")};
`;

export const Wrapper = styled.div`
	position: absolute;
	z-index: 1009;
	padding: ${typeScale(1)};
	top: ${typeScale(2)};
	right: ${typeScale(2)};
	display: flex;
	flex-direction: column;
	justify-content: center;
	background-color: ${getColor("porcelain")};
	color: ${getColor("white")};
	border-radius: ${typeScale(0.5)};
	cursor: pointer;
	transition: opacity 0.3s ease-in-out;

	@media (any-hover: hover) {
		&:hover {
			${StableHeart} {
				fill: ${getColor("salmon")};
				opacity: 0.75;
			}
		}
	}

	&.favorited {
		background-color: ${getColor("cosmos")};

		${StableHeart} {
			fill: ${getColor("salmon")};
			opacity: 1;
		}

		@media (any-hover: hover) {
			&:hover {
				${StableHeart} {
					opacity: 0.65;
				}
			}
		}
	}

	&.pressed {
		${StableHeart} {
			opacity: 1;
			transform: scale(0.8);
		}
	}

	&.poof {
		${FloatHeart} {
			animation: ${heartPoof} 800ms;
		}
	}
`;
